export default {
  actions: {
    RECEIVE_NAV: 'RECEIVE_NAV',
    RECEIVE_NAME: 'RECEIVE_NAME',
    SHOW_ACTIONS: 'SHOW_ACTIONS',
    NAV_ITEM: 'NAV_ITEM',
  },
};
